import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { StatusType, Withdrawal, WithdrawalParams } from '@/services/withdrawals/withdrawals.types';
import { AxiosInstance } from 'axios';

export const getWithdrawals = (client: AxiosInstance) => async (params?: WithdrawalParams) => {
  return (await client.get<PaginatedApiResponse<Withdrawal[]>>(API_ROUTES.GET_WITHDRAWAL_SETUP_LIST, { params })).data;
};

export const getWithdrawalDetail = (client: AxiosInstance) => async (withdrawalId?: string) => {
  return (
    await client.get<ApiResponse<Withdrawal>>(API_ROUTES.GET_WITHDRAWAL_DETAIL, {
      params: { withdrawalId: withdrawalId || '' },
    })
  ).data;
};

export const withdrawalsQueries = {
  all: () => ['withdrawals'],
  list: (type: StatusType, params?: WithdrawalParams) =>
    queryFactoryOptions<PaginatedApiResponse<Withdrawal[]>>({
      queryKey: [...withdrawalsQueries.all(), 'list', type, params],
      queryFn: (client: AxiosInstance) => () => getWithdrawals(client)(params),
    }),
  detail: (withdrawalId?: string) =>
    queryFactoryOptions<ApiResponse<Withdrawal>>({
      queryKey: [...withdrawalsQueries.all(), 'detail', withdrawalId],
      queryFn: (client: AxiosInstance) => () => getWithdrawalDetail(client)(withdrawalId),
    }),
};
